(function () {
  if (window.__alkaramCardAtc) return;
  window.__alkaramCardAtc = true;

  function instantAddToCart(button, variantId) {
    const originalText = button.innerText;
    button.innerText = '...';
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.7';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        button.innerText = originalText;
        button.style.pointerEvents = 'auto';
        button.style.opacity = '1';
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
        setTimeout(function () {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.setAttribute('open', '');
        }, 300);
      })
      .catch(function () {
        button.innerText = originalText;
        button.style.pointerEvents = 'auto';
        button.style.opacity = '1';
      });
  }

  function hydrateSizesTemplate(template) {
    if (!template || !template.parentNode) return;
    template.replaceWith(template.content.cloneNode(true));
  }

  function hydrateCardSizes(card) {
    const template = card.querySelector('template.product-card__sizes-template');
    if (template) hydrateSizesTemplate(template);
  }

  function hydrateQatcFromButton(button) {
    const next = button.nextElementSibling;
    if (next && next.matches && next.matches('template.product-card__qatc-template')) {
      const node = next.content.querySelector('.as-qatc-container');
      if (!node) return null;
      const clone = node.cloneNode(true);
      next.replaceWith(clone);
      return clone;
    }
    if (next && next.classList && next.classList.contains('as-qatc-container')) {
      return next;
    }
    return null;
  }

  function stampDeferredProductList(item) {
    if (!item) return;
    const template = item.querySelector('template.js-deferred-product-list');
    if (!template) return;
    template.replaceWith(template.content.cloneNode(true));
    observeSizeTemplates();
  }

  var sizeObserver;

  function observeSizeTemplates() {
    const templates = document.querySelectorAll('template.product-card__sizes-template');
    if (!templates.length) return;

    if (!('IntersectionObserver' in window)) {
      templates.forEach(hydrateSizesTemplate);
      return;
    }

    if (!sizeObserver) {
      sizeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            hydrateCardSizes(entry.target);
            sizeObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '120px 0px' }
      );
    }

    templates.forEach(function (template) {
      const card = template.closest('product-card');
      if (card) sizeObserver.observe(card);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const navButton = event.target.closest(
        '.featured-collections-navigation button'
      );
      if (navButton) {
        const nav = navButton.closest('carousel-navigation');
        const index = Array.prototype.indexOf.call(
          nav.querySelectorAll('button'),
          navButton
        );
        const carouselId = nav.getAttribute('aria-controls');
        const carousel = carouselId ? document.getElementById(carouselId) : null;
        const item = carousel
          ? carousel.querySelectorAll(':scope > .featured-collections-carousel__item')[index]
          : null;
        stampDeferredProductList(item);
      }

      const qatcButton = event.target.closest('.product-card-quick-add-button');
      if (qatcButton) hydrateQatcFromButton(qatcButton);

      const closeBtn = event.target.closest('.close-collection-button');
      if (closeBtn) {
        const container = closeBtn.closest('.as-qatc-container');
        if (container) container.classList.remove('active');
      }

      const sizeBtn = event.target.closest('.product-card__size-btn');
      if (sizeBtn && sizeBtn.dataset.variantId) {
        instantAddToCart(sizeBtn, sizeBtn.dataset.variantId);
      }
    },
    true
  );

  document.addEventListener(
    'pointerover',
    function (event) {
      const card = event.target.closest && event.target.closest('product-card');
      if (card) hydrateCardSizes(card);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSizeTemplates);
  } else {
    observeSizeTemplates();
  }
})();
